/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function(){
  
  setTimeout(function(){ 
  	$('.prod-middle-sec .prod-tabs #tabs .ui-tabs-nav .ui-tabs-tab a').click(function(e) {
      console.log("fard");
      return false;
    });
  }, 1000);
  
  
  
  
  $( "#tabs" ).tabs();
});


$(document).ready(function(){
	let data_onSale_bg = $('.label-color').attr("data-onSale-bg");
  	let data_onSale_text = $('.label-color').attr("data-onSale-text");
  
  	let data_soldOut_bg = $('.label-color').attr("data-soldOut-bg");
  	let data_soldOut_text = $('.label-color').attr("data-soldOut-text");
  
  	let data_new_bg = $('.label-color').attr("data-new-bg");
  	let data_new_text = $('.label-color').attr("data-new-text");
  
  	let data_discount_bg = $('.label-color').attr("data-discount-bg");
  	let data_discount_text = $('.label-color').attr("data-discount-text"); 
  
  	/*
  	$('body').attr("data-onSale-bg",data_onSale_bg);
  	$('body').attr("data-onSale-text",data_onSale_text);
  
  	$('body').attr("data-soldOut-bg",data_soldOut_bg);
  	$('body').attr("data-soldOut-text",data_soldOut_text);
  
  	$('body').attr("data-new-bg",data_new_bg);
  	$('body').attr("data-new-text",data_new_text);
  
  	$('body').attr("data-discount-bg",data_discount_bg);
  	$('body').attr("data-discount-text",data_discount_text); 
  	*/
  	setTimeout(function(){
  		change_product_label();
    },2000);
  
  	function change_product_label(){
  	$('span.ProductItem__Label.Heading.Text--subdued').each(function () {
    		if ($(this).text() == 'Sold out') {
              
        		$(this).css('background', data_soldOut_bg);
              	$(this).css('color', data_soldOut_text);
              
    		}else if ($(this).text() == 'On sale') {
              
        		$(this).css('background', data_onSale_bg);
              	$(this).css('color', data_onSale_text);
              
    		}else if ($(this).text() == 'New') {
              
        		$(this).css('background', data_new_bg);
              	$(this).css('color', data_new_text);
    		}else {
              
        		$(this).css('background', data_discount_bg);
              	$(this).css('color', data_discount_text);
    		}
		});
  }
  
});